import * as React from 'react';
import { Mixpanel } from 'mixpanel-browser';
export const MixpanelContext = React.createContext<null | Mixpanel>(null);